export default __webpack_public_path__ + "static/media/crewbb.7aba5efe.png";